import AspApi from "api/ApiConfig";

// broadcast list based on start and end endDate
export const broadcastList = async (brandId, startDate, endDate) => {
  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts/calendar?brand_id=${brandId}&start_date=${startDate}&end_date=${endDate}`
  );
  return res;
};
